// The person the family tree is drawn from: record #1, the family's founder.
//
// family-chart draws ONE person's ancestors and descendants. When it is not
// told who, it silently uses whoever is first in the data (family-chart.esm.js,
// calculateTree: `main_id = data_stash[0].id`). On 2026-09-09 a database change
// reordered the rows, the first person became someone with almost no
// relatives, and the family saw three cards. Naming the root removes that
// dependency on row order.
//
// Centring the view on the signed-in member is a separate step (cardToMiddle).
// It must NOT change the root, or the tree shrinks to that member's own line.
export const TREE_ROOT_ID = "1";
